<template v-slot:append>
  <v-dialog max-width="95%" persistent no-click-animation
      v-bind="computedProps"
      v-on="computedListeners"
      v-model="showDialog">
    <v-card min-height="75%" min-width="95%">
      <v-toolbar elevation="2" color="#2F75B5" dark dense>
        <v-spacer/>
        <v-toolbar-title>
          定型コース検索
        </v-toolbar-title>
        <v-spacer/>
        <v-btn @click="onCloseClick" text>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-container fluid>
          <v-expansion-panels v-model="expansionPanel" multiple flat>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <v-row ref="_calcHeight-Row1">
                  <v-col :cols="12">
                    <dd-sub-header>
                      検索条件
                    </dd-sub-header>
                  </v-col>
                </v-row>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row no-gutters align-content="center" ref="_calcHeight-Row2">
                  <v-col :cols="3">
                    <v-row no-gutters align-content="center">
                      <v-col :cols="6" class="px-1">
                        <dd-text-box
                          label="コースNo"
                          v-model="conditions.teikeiCourseNo"
                          ref="teikeiCourseNo"
                          :length="50"
                          :valueType="Ctrls.InputTypes.Number"/>
                      </v-col>
                    </v-row>
                  </v-col>

                  <v-col :cols="3">
                    <v-row no-gutters align-content="center">
                      <v-col :cols="12" class="px-1">
                        <dd-text-box
                          label="コース名称"
                          v-model="conditions.teikeiCourseNm"
                          ref="teikeiCourseNm"
                          :length="50"
                          :valueType="Ctrls.InputTypes.Free"/>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col :cols="3">
                    <v-row no-gutters align-content="center">
                      <v-col :cols="12" class="px-1">
                        <dd-code-text-box
                          label="顧客コード/名称"
                          v-model="conditions.ninushiCd"
                          ref="ninushiCd"
                          :length="100"
                          :required="false"
                          :valueType="Ctrls.InputTypes.Free"
                          titleText="取引先マスタ検索"
                          :headerList="mstTorihikisakiHeader"
                          item-value="torihikisakiCd"
                          item-text="torihikisakiNm"
                          :itemList="filteredMstTokuisakiList"/>
                      </v-col>
                    </v-row>
                  </v-col>

                  <v-col :cols="3">
                    <v-row no-gutters align-content="center">
                      <v-col :cols="6" class="px-1">
                        <dd-text-box
                          label="客先注文番号"
                          v-model="conditions.chumonNo"
                          ref="chumonNo"
                          :length="20"
                          :valueType="Ctrls.InputTypes.Free"/>
                      </v-col>
                    </v-row>
                  </v-col>

                </v-row>

                <v-row no-gutters align-content="center" ref="_calcHeight-Row3">
                  <v-col :cols="3">
                    <v-row no-gutters align-content="center">
                      <v-col :cols="12" class="px-1">
                        <dd-code-text-box
                          label="担当営業所コード/名称"
                          v-model="conditions.tantoEigyoshoCd"
                          ref="tantoEigyoshoCd"
                          :required=false
                          :length=100
                          :valueType="Ctrls.InputTypes.Free"
                          :itemList="filteredEigyoshoList"
                          titleText="営業所検索"
                          item-value="eigyoshoCd"
                          item-text="eigyoshoNm"
                          :headerList="mstEigyoshoHeader"
                          />
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col :cols="3" v-if="false">
                    <v-row no-gutters align-content="center">
                      <v-col :cols="12" class="px-1">
                        <dd-code-text-box
                          label="発注先コード/名称"
                          v-model="conditions.hacchusakiCd"
                          ref="hacchusakiCd"
                          :required="false"
                          :valueType="Ctrls.InputTypes.Free"
                          titleText="取引先マスタ検索"
                          :headerList="mstTorihikisakiHeader"
                          item-value="torihikisakiCd"
                          item-text="torihikisakiNm"
                          :itemList="filteredMstHacchusakiList"/>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col :cols="3">
                    <v-row no-gutters align-content="center">
                      <v-col :cols="12" class="px-1">
                        <dd-code-text-box
                          label="発地コード/名称"
                          v-model="conditions.hatsuchiCd"
                          ref="hatsuchiCd"
                          :length="100"
                          :required="false"
                          :valueType="Ctrls.InputTypes.Free"
                          titleText="発着地マスタ検索"
                          :headerList="mstHacchakuchiHeaders"
                          item-value="hacchakuchiCd"
                          item-text="hacchakuchiNm"
                          :itemList="filteredHacchakuchiList"/>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col :cols="3">
                    <v-row no-gutters align-content="center">
                      <v-col :cols="12" class="px-1">
                        <dd-code-text-box
                          label="着地コード/名称"
                          v-model="conditions.chakuchiCd"
                          ref="chakuchiCd"
                          :length="100"
                          :required="false"
                          :valueType="Ctrls.InputTypes.Free"
                          titleText="発着地マスタ検索"
                          :headerList="mstHacchakuchiHeaders"
                          item-value="hacchakuchiCd"
                          item-text="hacchakuchiNm"
                          :itemList="filteredHacchakuchiList"/>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col :cols="3">
                    <v-row no-gutters align-content="center">
                      <v-toolbar class="pa-0 ma-0" flat dense>
                        <v-spacer />
                        <dd-default-button
                          class="ml-2"
                          dark
                          dense
                          @click="onSearchButtonClick">
                          検索
                        </dd-default-button>
                        <dd-default-button
                          class="ml-2"
                          dark
                          dense
                          @click="onClearButtonClick">
                          クリア
                        </dd-default-button>
                      </v-toolbar>
                    </v-row>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

          <v-row no-gutters align-content="center" ref="_calcHeight-Row5">
            <v-col :cols="3">
              <dd-sub-header>
                一覧
              </dd-sub-header>
            </v-col>
            <v-col :cols="3" v-if="dialogMode==='0'">
            </v-col>
            <v-col :cols="3" v-if="dialogMode==='1'">
              <v-row no-gutters class="mt-4 px-2">
                <v-col :cols="6" class="px-1">
                  <dd-date-box
                    v-model="addConditions.unkoYmd"
                    label="作成運行日"
                    ref="unkoYmd"
                    max="2999/12/31"
                    min="2000/01/01"
                    :readonly="false"
                    :required="true"
                  />
                </v-col>
                <v-col :cols="6" class="px-1">
                  <dd-date-box
                    v-model="addConditions.hatsuchiYmd"
                    label="作成発日"
                    ref="HatsuchiYmd"
                    max="2999/12/31"
                    min="2000/01/01"
                    :readonly="false"
                    :required="true"
                  />
                </v-col>
              </v-row>
            </v-col>
            <v-col :cols="1"></v-col>
            <v-col :cols="3">
              <dd-narrow-down-text-box v-model="searchText" :length=10 />
            </v-col>
            <v-col :cols="1">
              <dd-row-count-box
                label="全件数"
                v-model="rowCount"/>
            </v-col>
            <v-col :cols="1">
              <dd-row-count-box
                label="絞込結果"
                v-model="filteredRowCount"/>
            </v-col>
          </v-row>
          <v-row no-gutters align-content="center">
            <v-col :cols="12">
              <dd-data-table
                v-model="selectedItem"
                calculate-widths
                :height="calcHeightTable"
                item-key="id"
                showSelect
                :singleSelect="singleSelect"
                @click:row="onRowClick"
                :headers="headers"
                :items="filteredRows"
                :search="searchText"
                :loading="loading"
                :header-props="{sortByText: '並び替え'}"
                :footer-props="{'items-per-page-options': [100, 200, 300, 400, 500],showFirstLastPage: true,}"
                loading-text="検索中のため、少々お待ちください。"
                :itemsPerPage=100
                fixed-header
                locale="ja-jp"
                no-data-text="利用可能なデータはありません。"
                dense
                :page.sync ="page"
                />
            <!--
              @dblclick:row="onRowDoubleClick"
            -->
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <dd-footer-button
          @click="onCloseClick">
          閉じる
        </dd-footer-button>
        <v-spacer></v-spacer>
        <dd-footer-button
          v-if="dialogMode==='0'"
          :disabled="isSelectButtonDisabled"
          @click="onSelectButtonClick">
          選択
        </dd-footer-button>
        <dd-footer-button
          v-if="dialogMode==='1'"
          :disabled="isSelectButtonDisabled"
          @click="onCreateExec">
          受注作成
        </dd-footer-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import controls from '@/rahmen/controls'
import modals from '@/ddv2.library/modals'

import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import header from '@/ddv2.library/header'
import Swal from 'sweetalert2'

import { mapGetters } from 'vuex'

const DdCodeTextBox = () => import('@/components/DdCodeTextBox')
const DdDataTable = () => import('@/components/DdDataTable')
const DdDateBox = () => import('@/components/DdDateBox')
const DdDefaultButton = () => import('@/components/DdDefaultButton')
const DdFooterButton = () => import('@/components/DdFooterButton')
const DdNarrowDownTextBox = () => import('@/components/DdNarrowDownTextBox')
const DdRowCountBox = () => import('@/components/DdRowCountBox')
const DdSubHeader = () => import('@/components/DdSubHeader')
const DdTextBox = () => import('@/components/DdTextBox')

export default {
  name: 'DdTeikeiCorseSearchDialog',
  mixins: [flowMixin],
  components: {
    DdCodeTextBox,
    DdDataTable,
    DdDateBox,
    DdDefaultButton,
    DdFooterButton,
    DdNarrowDownTextBox,
    DdRowCountBox,
    DdSubHeader,
    DdTextBox
  },
  props: {
    /**
     * 表示状態
     */
    showDialog: Boolean,
    /**
     * ダイアログタイトル
     */
    titleText: String,
    /**
     * コンプリートリスト
     */
    itemList: Array,
    /**
     * 1行選択
     */
    singleSelect: {
      type: Boolean,
      default: true
    },
    /**
     * 実行モード(0:選択モード,1:追加モード)
     */
    dialogMode: {
      type: String,
      default: '0'
    },
    param: {
      HaishaYmd: '',
      startHM: ''
    }
  },
  data: () => ({
    conditions: {
      teikeiCourseNo: '',
      teikeiCourseNm: '',
      ninushiCd: '',
      chumonNo: '',
      tantoEigyoshoCd: '',
      hacchusakiCd: '',
      hatsuchiCd: '',
      chakuchiCd: ''
    },
    addConditions: {
      HaishaYmd: '',
      startHM: '',
      unkoYmd: '',
      hatsuchiYmd: ''
    },
    // フィルター定義 －－ここから－－
    teikeiCourseFilterConditions: {
      teikeiCourseNo: '',
      teikeiCourseNm: '',
      ninushiCd: '',
      tantoEigyoshoCd: '',
      hacchusakiCd: '',
      hatsuchiCd: '',
      chakuchiCd: ''
    },
    // フィルター定義 －－ここまで－－
    searchText: '',
    ctypes: controls,
    // 拡張パネル
    expansionPanel: [0, 1],
    /**
     * 一覧内容
     */
    rows: [],
    loading: false,
    selectedItem: [],
    page: 1
    /*
     *
     */
  }),

  created () {
    console.log('screen created')
    this.$store.dispatch('system/setViewTitle', '固定貨物検索')
    this.mstEigyoshoHeader = header.mstEigyoshoHeaders
    this.mstTorihikisakiHeader = header.mstTorihikisakiHeaders
    this.mstHacchakuchiHeaders = header.mstHacchakuchiHeaders
  },
  mounted () {
    this.initialize()
  },
  watch: {
    showDialog: function (n) {
      if (n === true) {
        this.initBindVariables()
      }
    }
  },
  computed: {
    ...mapGetters({
      eigyoshoList: 'DDMasters/mstEigyosho',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      hacchakuchiList: 'DDMasters/mstHacchakuchi'
    }),
    // 営業所マスタフィルター --> ここから
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn === '01'
      })
    },
    // 営業所マスタフィルター <-- ここまで
    // 取引先マスタフィルター --> ここから
    filteredMstTorihikisaki () {
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      })
    },
    filteredMstTokuisakiList () {
      const target = filter.dateFormatter(new Date())
      return this.filteredMstTorihikisaki.filter((t) => {
        return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.tokuisakiFlg === true
      })
    },
    filteredMstHacchusakiList () {
      const target = filter.dateFormatter(new Date())
      return this.filteredMstTorihikisaki.filter((t) => {
        return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.hacchusakiFlg === true
      })
    },
    // 取引先マスタフィルター <-- ここまで
    // 発着地マスタフィルター --> ここから
    filteredHacchakuchiList () {
      const target = filter.dateFormatter(new Date())
      return this.hacchakuchiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      })
    },
    // 発着地マスタフィルター <-- ここまで
    filteredRows () {
      const self = this
      return this.rows.filter(function (elem) {
        return self.isTeiekiCourseSearchCheck(elem)
      })
    },
    computedProps () {
      return {
        ...this.$props,
        persistent: true,
        noClickAnimation: true,
        maxWidth: '85%'
      }
    },
    computedListeners () {
      return {
        ...this.$listeners
      }
    },
    isSelectButtonDisabled () {
      return this.selectedItem.length === 0
    },
    calcHeightTable () {
      if (this.expansionPanel.length === 1) {
        return this.tableHeight * 0.8
      }
      return this.tableHeight * 0.41
    }
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: [],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            console.log('ThKoteiKamotsuNoSearchDialog.defineHeaderPromise')
            self.headers = [
              { text: 'コースNo', value: 'teikeiCourseNo' },
              { text: 'コース名称', value: 'teikeiCourseNm' },
              { text: '顧客名称', value: 'ninushiDisp' },
              { text: '客先注文番号', value: 'chumonNo' },
              { text: '車種', value: 'seikyuShashuSbtNm' },
              /*
              { text: '契約種別', value: 'keiyakuSbtNm' },
              { text: '運行種別', value: 'unkoSbtNm' },
              { text: '運行間隔', value: 'unkoKankakuSbtNm' },
              { text: '作業日備考', value: 'sagyoYoteiBiko' },
              */
              { text: '担当営業所', value: 'tantoEigyoshoDisp' },
              { text: '貨物区分', value: 'kamotsuKbnNm' },
              // { text: '発注先', value: 'hacchusakiDisp' },
              { text: '発地', value: 'hatsuchiDisp' },
              { text: '発時刻', value: 'hatsuchiHms' },
              { text: '発時刻指定', value: 'startLockFlgDisp' },
              // { text: '接車時刻', value: 'hatsuchiHmsBiko' },
              { text: '経由地１', value: 'keiyuchiId1Disp' },
              { text: '経由地２', value: 'keiyuchiId2Disp' },
              { text: '経由地３', value: 'keiyuchiId3Disp' },
              { text: '経由地４', value: 'keiyuchiId4Disp' },
              { text: '経由地５', value: 'keiyuchiId5Disp' },
              { text: '着地', value: 'chakuchiDisp' },
              { text: '着時刻', value: 'chakuchiHms' },
              { text: '着時刻指定', value: 'endLockFlgDisp' },
              { text: '請求運賃計算方法区分', value: 'seikyuUnchinKeisanKbnNm' },
              { text: '請求運賃', value: 'seikyuKihonUnchin', align: 'end' },
              { text: '請求有料代', value: 'seikyuTsukoryo', align: 'end' },
              { text: '請求立替金', value: 'seikyuKingaku1', align: 'end' },
              { text: '請求貨物保険料', value: 'seikyuKingaku2', align: 'end' },
              { text: '請求合計', value: 'seikyuGokei', align: 'end' },
              { text: '配車備考', value: 'haishaBiko' },
              { text: 'その他連絡', value: 'renrakuBiko' }
            ]
            resolve()
          })
        },
        initializeInputPromise: (c) => {
          this.initBindVariables()
        },
        savedInputRestorePromise: (c) => {
          console.log('savedInputRestorePromise')
          // ユーザ保存項目の復元
          return new Promise(resolve => {
            this.loadFromCache()
              .then((c) => {
                console.log('ThKoteiKamotsuNoSearchDialog.savedInputRestorePromise', c)
                resolve()
              })
          })
        },
        settingViewScroll: () => {
          return true
        },
        researchPromise: (c) => {
          console.log('ThKoteiKamotsuNoSearchDialog.researchPromise', c)
          return new Promise(resolve => {
            this.conditions = c.cache.value.conditions || {}
            this.onSearchButtonClick()
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          console.log('ThKoteiKamotsuNoSearchDialog.restoreViewPromise', c)
          return new Promise(resolve => {
            this.conditions = c.cache.value.conditions || {}
            this.searchText = c.cache.value.searchText || ''
            this.rows = c.cache.value.rows || []
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('ThKoteiKamotsuNoSearchDialog.settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            resolve()
          })
        },
        settingLoadEffect: function () {
          return true
        }

      }
      this.initializeForViewer(opt)
    },
    onRowDoubleClick: function (e, f) {
      /**
       * 選択時クローズ処理
       * @event doubleClick
       * @type {Event}
       */
      console.log('row double clicked', e)
      console.log('row double clicked', f)
      this.$emit('close', f.item)
      this.initBindVariables()
      this.searchText = ''
      this.selectedItem = []
    },
    onRowClick: function (e) {
      /**
       * 選択処理
       * @event Click
       * @type {Event}
       */
      console.log('row clicked', e, this.searchText)
      this.selectedItem = [e]
      /*
      if (this.selectedItem.length === 0) {
        this.selectedItem = [e]
      } else {
        this.selectedItem = []
      }
      */
    },
    onSelectButtonClick: function (e) {
      /**
       * 選択ボタン押下処理
       * @event click
       * @type {Event}
       */
      console.log('select clicked', e, this.selectedItem)
      if (this.selectedItem.length === 0) {
        this.$emit('close', false)
      } else {
        this.$emit('close', this.selectedItem[0])
      }
      this.initBindVariables()
      this.searchText = ''
      this.selectedItem = []
    },
    onSearchButtonClick: function (e) {
      this.selectedItem = []
      this.teikeiCourseFilterConditions = Object.assign({}, this.conditions)
    },
    isTeiekiCourseSearchCheck (elem) {
      const self = this
      return (!self.teikeiCourseFilterConditions.teikeiCourseNo || String(elem.teikeiCourseNo).indexOf(self.teikeiCourseFilterConditions.teikeiCourseNo) !== -1) &&
      (!self.teikeiCourseFilterConditions.teikeiCourseNm || elem.teikeiCourseNm.indexOf(self.teikeiCourseFilterConditions.teikeiCourseNm) !== -1) &&
      (!self.teikeiCourseFilterConditions.ninushiCd || elem.ninushiCd === self.teikeiCourseFilterConditions.ninushiCd) &&
      (!self.teikeiCourseFilterConditions.chumonNo || elem.chumonNo === self.teikeiCourseFilterConditions.chumonNo) &&
      (!self.teikeiCourseFilterConditions.tantoEigyoshoCd || elem.tantoEigyoshoCd === self.teikeiCourseFilterConditions.tantoEigyoshoCd) &&
      (!self.teikeiCourseFilterConditions.hacchusakiCd || elem.hacchusakiCd === self.teikeiCourseFilterConditions.hacchusakiCd) &&
      (!self.teikeiCourseFilterConditions.hatsuchiCd || elem.hatsuchiCd === self.teikeiCourseFilterConditions.hatsuchiCd) &&
      (!self.teikeiCourseFilterConditions.chakuchiCd || elem.chakuchiCd === self.teikeiCourseFilterConditions.chakuchiCd)
    },
    onClearButtonClick: function (e) {
      this.Effects.loadStart()
      this.clear()
    },
    clear: function () {
      console.log('NewButton pushed')
      const p = modals.showConfirm
      p('COMQ0006').then((ok) => {
        console.log('clearInputs')
        if (ok === false || ok === undefined) { return }
        this.initBindVariables()
        this.searchText = ''
        this.rows = this.itemList
        this.selectedItem = []
      })
      this.Effects.loadComplete()
    },
    onCloseClick: function (e) {
      /**
       * 無選択クローズ処理
       * @event click
       * @type {Event}
       */
      console.log('close clicked', this.showDialog)
      this.$emit('close', false)
      console.log('emited', this.showDialog)
      // this.clear(false)
      this.initBindVariables()
      this.searchText = ''
      this.selectedItem = []
    },
    searchValidate: function () {
      return true
    },
    // --------------------------------------------------------------------------------
    // 定型追加処理
    // --------------------------------------------------------------------------------
    onCreateExec: function (e) {
      this.onCreateExecAction()
      console.log(e)
    },
    onCreateExecAction: function () {
      const self = this
      const opt = {
        registerRequestPromise: self.registerPromise,
        registerResponsePromise: (data) => {
          return new Promise(resolve => {
            var rex = data.payload
            if (rex !== '') {
              this.showError(rex)
            } else {
              this.showSuccess('定型からの受注作成が完了しました')
              this.$emit('exec', true)
            }
            resolve()
          })
        },
        getIdMethod: () => {
          return 0
        },
        continuousInputInitializePromise: (id) => {
          return new Promise(resolve => {
            resolve()
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        },
        isUpdateModeMethod: function () {
          return true
        },
        isNoRefreshModeMethod: function () {
          return true
        },
        isNoMessageModeMethod: function () {
          return true
        }
      }
      this.register(opt)
    },
    registerPromise: function () {
      var itemlist = []
      this.selectedItem.forEach(p => {
        itemlist = itemlist.concat(p.teikeiCourseNo)
      })
      console.log('onCreateExecAction foreachOut', itemlist)
      var addData = {
        kaishaCd: this.selectedItem[0].kaishaCd,
        startHM: this.addConditions.startHM,
        unkoYmd: this.addConditions.unkoYmd,
        hatsuchiYmd: this.addConditions.hatsuchiYmd,
        teikeiCourseNo: itemlist.join(',')
      }
      const f = this.HttpClient.post('/api/v1/D2Plmd0010/CopyTeikei', addData)
      return f
    },
    registerValidate: function () {
      return true
    },
    // ----------------------------------------------------------------------------------------------------
    // 内部共通関数
    // ----------------------------------------------------------------------------------------------------
    initBindVariables: function () {
      this.rows = this.itemList
      this.conditions = {
        teikeiCourseNo: '',
        teikeiCourseNm: '',
        ninushiCd: '',
        chumonNo: '',
        tantoEigyoshoCd: '',
        hacchusakiCd: '',
        hatsuchiCd: '',
        chakuchiCd: ''
      }
      this.addConditions = {
        startHM: this.param.startHM,
        unkoYmd: this.param.HaishaYmd,
        hatsuchiYmd: this.param.HaishaYmd
      }
      this.teikeiCourseFilterConditions = Object.assign({}, this.conditions)
    },
    // ダイアログメッセージ
    showError: function (msg) {
      Swal.fire({
        icon: 'error',
        html: msg
      })
    },
    showSuccess: function (msg) {
      Swal.fire({
        icon: 'success',
        html: msg
      })
    }
  }
}
</script>
<style scoped>
div.v-dialog__content.v-dialog__content--active {
   z-index: 520 !important;
}
</style>
